module.exports = __webpack_public_path__ + "img/loading_console.7b6917d4.svg";